/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-04-29 17:47:59
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-04-10 11:53:50
 */
import { ActionContext } from 'vuex'
import { IStore, IUserState, IUserInfo } from '@/store/types.d'
import { IUserLogin } from '@/api/types.d'
import { setStorageItem, getStorageItem, deepClone } from '@/utils/util'
import api from '@/api'
import routes from '@/router/routes'
import { RouteRecordRaw } from 'vue-router'
import { RouterNameEnum } from '@/enums/routerEnum'
import { RoleEnum } from '@/enums/roleEnum'
import userApi from '@/api/user'
import { getStorageNodesList } from '@/api/storage-node'
import { key } from '..'
const { READ_ONLY, OPERATE_READ } = RoleEnum

const {
  HOME_ROUTER_NAME,
  APP_CARD_LIST_ROUTER_NAME,
  APP_SETTING_ROUTER_NAME,
  BASE_SERVER_ROUTER_NAME,
  BASE_SERVER_USER_ROUTER_NAME,
  BASE_SERVER_ROLE_ROUTER_NAME,
  SETTING_ROUTER_NAME,
  // OPEN_LESS_ROUTER_NAME,
  OPEN_LESS_EXTENDED_APPLICATION_ROUTER_NAME,
  OPEN_LESS_EXTERNAL_ACCESS_ROUTER_NAME,
  LICENSE_DETAIL,
  SEC_KEY_MAN,
  LICENSE_NAME,
  OPERATE_CENTER,
  REMOTE_APPLICATION,
  REMOTE_APPLICATION_DETAILS,
  APPLICATION_AUTH,
  APPLICATION_MANAGEMENT,
  APPLICATION_KEY,
  PRODUCT_INSTALL_RECORD_ROUTER_NAME,
  ALGORITHM_SHOP_ROUTER_NAME,
  APP_SHOP_ROUTER_NAME,
  APP_SHOP_DETAILS_ROUTER_NAME,
  ROOT_ROUTER_NAME,
  ALGORITHM_DETAILS_ROUTER_NAME,
  SYSTEM_USER_ROUTER_NAME,
  ONLINE_SHOP_ROUTER_NAME,
  SYSTEM_LOG_ROUTER_NAME,
  SYSTEM_SERVICE_ROUTER_NAME,
  FILE_PUBLISH,
  ALGORITHM_GROUP_ROUTER_NAME,
  CRRS
} = RouterNameEnum

// 权限菜单
const getAllAccessButtons = () => ({
  [BASE_SERVER_USER_ROUTER_NAME]: [
    'user-depart-add',
    'user-depart-delete',
    'user-depart-edit',
    'user-add-user',
    'user-depart-setting',
    'user-batch-import',
    'user-batch-delete',
    'user-table-edit',
    'user-table-delete'
  ],
  [BASE_SERVER_ROLE_ROUTER_NAME]: [
    'role-add',
    'role-delete',
    'role-edit',
    'role-add-user',
    'role-batch-delete',
    'role-password',
    'role-delete-user'
  ],
  [LICENSE_DETAIL]: [],
  [SEC_KEY_MAN]: ['key-add', 'key-detail', 'key-delete'],
  [LICENSE_NAME]: ['license-add', 'license-delete', 'license-detail'],
  [SETTING_ROUTER_NAME]: ['sys-setting-title-edit', 'sys-setting-logo', 'sys-setting-icon'],
  [APPLICATION_KEY]: ['key-add', 'key-filter', 'key-detail', 'key-delete'],
  [APPLICATION_AUTH]: ['auth-add', 'auth-filter', 'auth-detail', 'auth-delete'],
  [PRODUCT_INSTALL_RECORD_ROUTER_NAME]: [],
  [ALGORITHM_SHOP_ROUTER_NAME]: [
    'algorithm-add',
    'algorithm-detail',
    'algorithm-delete',
    'algorithm-global-edit',
    'algorithm-export',
    'algorithm-edit'
  ],
  [ALGORITHM_GROUP_ROUTER_NAME]: ['algorithm-add', 'algorithm-edit', 'algorithm-delete'],
  [APP_SHOP_ROUTER_NAME]: [
    'app-shop-add',
    'app-shop-detail',
    'app-shop-delete',
    'app-up',
    'app-down',
    'app-detail-get-new-v',
    'app-detail-edit',
    'app-download-sh'
  ],
  [REMOTE_APPLICATION]: [
    'cache-clean',
    'remote-app-add',
    'remote-app-delete',
    'key-copy',
    'key-refresh',
    'app-push-change'
  ],
  [REMOTE_APPLICATION_DETAILS]: ['remote-app-detail'],
  [APP_SHOP_DETAILS_ROUTER_NAME]: [],
  [ALGORITHM_DETAILS_ROUTER_NAME]: [],
  [ONLINE_SHOP_ROUTER_NAME]: [],
  [SYSTEM_SERVICE_ROUTER_NAME]: [],
  [SYSTEM_LOG_ROUTER_NAME]: ['log-filter'],
  [FILE_PUBLISH]: [],
  [CRRS]: ['crrs-add', 'crrs-edit', 'crrs-delete']
})

// 将后端返回数据处理前端格式
function transformDataToInit(permissions: any[]) {
  const permissionsInfo = {
    operate: OPERATE_READ,
    read: READ_ONLY
  }

  const role = {}

  if (!permissions || !permissions.length) {
    return
  }

  permissions.forEach((item) => {
    const { permissionType, operation } = item
    if (role[permissionType]) {
      if (role[permissionType] < permissionsInfo[operation]) {
        role[permissionType] = permissionsInfo[operation]
      }
    } else {
      role[permissionType] = permissionsInfo[operation]
    }
  })

  return role
}

// 非 admin用户
const getHeaderMenu = (menu: any[], role: any) => {
  const arr: any[] = []

  menu.forEach((item: any) => {
    const children: any[] = item.children
    const len = children.length

    const obj: any = {
      ...deepClone(item),
      fullPath: item.path
    }

    for (let i = 0; i < len; i++) {
      const child: any = children[i]
      const roleKey: string = child.name

      const ret = child.children.filter((item) => {
        return role[item.name] > 0
      })
      if (role[roleKey] > 0 && ret.length) {
        arr.push(obj)
        // obj.fullPath = obj.fullPath + (child.path ? '/' + child.path : '')
        break
      }
    }
  })
  return arr
}

// 设置权限按钮集合
const setAccessButtons = (role: any, isAdmin: boolean) => {
  const btnList = []
  const accessBtns = getAllAccessButtons()
  const pageAllButtons = []

  Object.keys(accessBtns).forEach((key: string) => {
    pageAllButtons.push(...accessBtns[key])
  })

  if (isAdmin) {
    Object.keys(accessBtns).forEach((key: string) => {
      btnList.push(...accessBtns[key])
    })
  } else {
    Object.keys(role).forEach((key: string) => {
      if (role[key] === OPERATE_READ && accessBtns[key]) {
        btnList.push(...accessBtns[key])
      }
    })
  }

  return {
    accessButtons: btnList,
    pageAllButtons
  }
}

// 获取侧边栏菜单
const getSideBar = (menu: any[], rootPath: string, role?: any) => {
  menu = menu.filter((item: any) => {
    const children: any[] = item.children
    if (children && children.length) {
      if (role) {
        item.children = getSideBar(children, item.path, role)
      } else {
        item.children = getSideBar(children, item.path)
      }
    }

    if (item.path) {
      item.path = `${rootPath}/${item.path}`
    }

    return role
      ? item.path !== '' && role[item.name] && role[item.name] !== RoleEnum.NO_PERMISSION
      : item.path !== ''
  })
  return menu
}

const state: IUserState = {
  token: getStorageItem('token') || '',
  userInfo: getStorageItem('userInfo') || {
    name: 'admin',
    avatar: '',
    account: '',
    userId: '',
    isOriginalPw: 0
  },
  cacheUserInfo: null,
  isAdmin: false,
  role: {
    [ROOT_ROUTER_NAME]: 1,
    [HOME_ROUTER_NAME]: 1,
    [APPLICATION_MANAGEMENT]: 1,
    [SYSTEM_USER_ROUTER_NAME]: 1,
    [FILE_PUBLISH]: 1,
    [ONLINE_SHOP_ROUTER_NAME]: 1,
    [SYSTEM_SERVICE_ROUTER_NAME]: 1,
    [APP_CARD_LIST_ROUTER_NAME]: 0,
    [APP_SETTING_ROUTER_NAME]: 0,
    [BASE_SERVER_ROUTER_NAME]: 1,
    [BASE_SERVER_USER_ROUTER_NAME]: 0,
    [BASE_SERVER_ROLE_ROUTER_NAME]: 0,
    [SETTING_ROUTER_NAME]: 0,
    [OPEN_LESS_EXTENDED_APPLICATION_ROUTER_NAME]: 0,
    [OPEN_LESS_EXTERNAL_ACCESS_ROUTER_NAME]: 0
  },
  headerMenu: [],
  sideBarMenu: {
    [BASE_SERVER_ROUTER_NAME]: [],
    // [LICENSE_CENTER]: [],
    [OPERATE_CENTER]: []
    // [OPEN_LESS_ROUTER_NAME]: []
  },
  accessButtons: [],
  pageAllButtons: [],
  sysSetting: false,
  hasGetCurUser: false,
  internalIp: ''
}

const mutations = {
  SET_TOKEN: (state: IUserState, token: string) => {
    state.token = token
    setStorageItem('token', token)
  },
  SET_USER_INFO: (state: IUserState, userInfo: IUserInfo) => {
    state.userInfo = userInfo
    setStorageItem('userInfo', userInfo)
  },
  LOGIN_OUT: (state: IUserState) => {
    state.token = ''
    document.cookie = ``
    state.userInfo = null
    state.role = null
    state.headerMenu = []
    window.localStorage.clear()
    window.location.href = '/'
  },
  //  设置当前用户以及菜单
  SET_CUR_USER: (state: IUserState, { role, isAdmin }: any) => {
    role = role || state.role

    state.hasGetCurUser = true
    state.isAdmin = isAdmin
    state.sysSetting = isAdmin ? true : !!role[SETTING_ROUTER_NAME]

    const menu: any[] = deepClone(routes).filter((router: RouteRecordRaw) => {
      const meta = router.meta

      return meta && meta.isHeaderMenu
    })

    // 权限按钮集合
    const { accessButtons, pageAllButtons } = setAccessButtons(role, isAdmin)
    state.accessButtons = accessButtons
    state.pageAllButtons = pageAllButtons

    //  admin用户
    if (isAdmin) {
      // 头部菜单
      Object.keys(state.role).forEach((key: string) => {
        state.role[key] = RoleEnum.OPERATE_READ
      })

      state.headerMenu = menu.map((item: any) => {
        item.fullPath = item.path

        return item
      })

      // 侧边栏菜单
      Object.keys(state.sideBarMenu).forEach((key: string) => {
        const curRouter: any = deepClone(routes).filter((router: any) => router.name === key)[0]

        state.sideBarMenu[key] = getSideBar(curRouter.children, curRouter.path)
      })
    } else {
      state.role = {
        ...state.role,
        ...role
      }
      state.headerMenu = getHeaderMenu(menu, state.role)
      Object.keys(state.sideBarMenu).forEach((key: string) => {
        const curRouter: any = deepClone(routes).filter((router: any) => router.name === key)[0]
        state.sideBarMenu[key] = getSideBar(curRouter.children, curRouter.path, state.role)
      })
    }
  },
  SET_INTERNAL_IP: (state: IUserState, ip: string) => {
    state.internalIp = ip
  },
  CACHE_SET_USER: (state: IUserState, user: IUserInfo) => {
    state.cacheUserInfo = user
  }
}

const actions = {
  // 登录
  async login({ commit }: ActionContext<IUserState, IStore>, opt: IUserLogin) {
    const res = await api.login(opt)

    if (res && !res.type) {
      const { token, name, picture, userId, isOriginalPw } = res
      const user = {
        name,
        avatar: picture,
        userId,
        isOriginalPw
      }
      if (!isOriginalPw) {
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', user)
      } else {
        commit('CACHE_SET_USER', { ...user, token, old_password: opt.password })
        return user
      }
    }
    return res
  },
  updateUserInfo({ commit }: ActionContext<IUserState, IStore>, user) {
    commit('SET_USER_INFO', user)
    commit('SET_TOKEN', user.token)
  },
  async saveIntervalIp({ commit }: ActionContext<IUserState, IStore>) {
    // 获取一下内网ip  登录后保存一下
    const param = {
      location: '深圳'
    }
    const node = await getStorageNodesList(param)
    if (node) {
      const { data } = node
      commit('SET_INTERNAL_IP', data[0].privateUrl)
    }
  },
  async logout({ commit }: ActionContext<IUserState, IStore>, userId: string) {
    const res = await api.logout(userId)

    if (res) {
      commit('LOGIN_OUT')

      return res
    }
  },

  // 查询用户信息
  async fetchUser({ commit, state }: ActionContext<IUserState, IStore>) {
    const res = await userApi.checkUserAuth(state.userInfo.userId)

    if (res) {
      const { permissions, is_admin } = res
      const role = transformDataToInit(permissions)
      commit('SET_CUR_USER', { role, isAdmin: is_admin })
      return res
    }
  }
}

const user = {
  state,
  mutations,
  actions
}

export default user
